import { render, staticRenderFns } from "./foldSwiper.vue?vue&type=template&id=a96bd8ac&scoped=true&"
import script from "./foldSwiper.vue?vue&type=script&lang=js&"
export * from "./foldSwiper.vue?vue&type=script&lang=js&"
import style0 from "./foldSwiper.vue?vue&type=style&index=0&id=a96bd8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96bd8ac",
  null
  
)

export default component.exports